import React from 'react';
import { Field } from 'formik';
import TextInput from './TextInput';
import SelectStyled from './Select';

function enhanceWithFormikControls(
  Component,
  defaultValue,
  { passErrorState }
) {
  ComponentWithFormik.propTypes = {
    ...Field.propTypes,
    ...Component.propTypes,
  };

  function ComponentWithFormik({ field, form, ...props }) {
    const additionalProps = {};
    if (passErrorState) {
      additionalProps.hasError = Boolean(
        form.errors && form.errors[field.name] && form.touched[field.name]
      );
    }
    return (
      <Component
        name={field.name}
        value={field.value != null ? field.value : defaultValue}
        onChange={(...args) => {
          field.onChange(...args);
        }}
        onBlur={field.onBlur}
        {...props}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            form.handleSubmit();
          }
        }}
        {...additionalProps}
      />
    );
  }

  return ComponentWithFormik;
}

function enhanceWithFormikField(Component, defaultValue, options = {}) {
  ComponentWithFormik.propTypes = {
    ...Field.propTypes,
    ...Component.propTypes,
  };
  const WithFormikControls = enhanceWithFormikControls(
    Component,
    defaultValue,
    options
  );

  function ComponentWithFormik(props) {
    const { name } = props;
    return (
      <>
        <Field component={WithFormikControls} {...props} />
      </>
    );
  }

  return ComponentWithFormik;
}

function FormikWorkaroundSelect(props) {
  return (
    <>
      <Field component={SelectWrapper} {...props} />
    </>
  );
}

function SelectWrapper(props) {
  const { field, options, form } = props;
  return (
    <SelectStyled
      {...props}
      value={options.find((option) => option.value === field.value)?.value || ''}
      onChange={(event) => {
        form.setFieldValue(field.name, event.target.value);
      }}
    />
  );
}

export const TextField = enhanceWithFormikField(TextInput, '', {
  passErrorState: true,
});

export const Select = FormikWorkaroundSelect;
